import React, { FC, useMemo } from 'react';
import Script from 'next/script';
import { BatchContactProvider } from '@component/hooks/search/batchContact';
import SearchBase from './base';
import Head from 'components/head';
import { useQueryString } from '@tyc-pc/core';
import getServerSideProps from '@component/search/ssr/getServerSideProps';

const Search: FC = () => {
  const { key, base } = useQueryString();
  // TODO 整体title base内容映射中文显示功能确实，待后期补充
  const Search_TDK = useMemo(() => {
    return {
      title: (() => {
        if (key) {
          return `${key}_相关搜索结果-天眼查`;
        } else if (base) {
          return '公司信息查询_企业【信用_工商_注册】信息查询-天眼查';
        } else {
          return '相关搜索结果-天眼查';
        }
      })(),
      description: `天眼查专注服务于个人与企业信息查询，都在用的商业查询平台，在这里您可以查询${key}相关信息，包括${key}工商信息、注册信息等，了解更多${key}相关搜索结果就上天眼查官网！`,
      keywords: `${key},${key}工商信息,${key}信息查询`,
    };
  }, []);

  return (
    <BatchContactProvider>
      {Search_TDK.title && (
        <Head
          title={Search_TDK.title}
          description={Search_TDK.description}
          keywords={Search_TDK.keywords}
        />
      )}
      <SearchBase />
      <Script src="https://cdn.tianyancha.com/tyc-web-next/lib/gt.js" />
    </BatchContactProvider>
  );
};

export default Search;
export { getServerSideProps };
